import { render, staticRenderFns } from "./RecepcionActividadForm.vue?vue&type=template&id=738ab6fc&"
import script from "./RecepcionActividadForm.vue?vue&type=script&lang=ts&"
export * from "./RecepcionActividadForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('738ab6fc', component.options)
    } else {
      api.reload('738ab6fc', component.options)
    }
    module.hot.accept("./RecepcionActividadForm.vue?vue&type=template&id=738ab6fc&", function () {
      api.rerender('738ab6fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Recepcion/RecepcionActividadForm.vue"
export default component.exports